export class DynamicAttributeSummarizedItem {
    isHidden: boolean =true;
    isFieldSet: boolean;
    label: string;
    value: string;
    oldValue: string;
    useOldValue: boolean;
    position: number;
    sortorder: number;
    rightLevel: number;
    parent: DynamicAttributeSummarizedItem;
    children: DynamicAttributeSummarizedItem[]= [] ;
}
